import * as actions from '@app/actions/index';
import * as models from '@app/models/index';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import ProfileComponent from './profile.component';

function mapStateToProps(state: models.IProfileState): models.IProfileState {
	return {
		...state,
	};
}

function mapDispatchToProps(dispatch: Dispatch<actions.AuthActions>): models.IProfileProps {
	return {
		intl: null,
		openSnackBar: null,
		onCloseAccount: () => dispatch(actions.userClosedAccountAction()),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileComponent);



// WEBPACK FOOTER //
// ./src/components/account/profile/profile.ts